import globals from '../../common/globals';
import { eventBus, globalEventBus } from '../../../modules/event-bus';
import videoPlayer from '../../common/vx-video-player/vx-video-player.vue';
import vxModal from '../../common/vx-modal/vx-modal.vue';
import mobileMixin from '../../common/mixins/mobile-mixin';
import viewSiteContent from '../../../locale/view-site-content-i18n';

export default {
  name: 'vx-image-title',
  components: {
    vxModal,
    videoPlayer,
  },
  mixins: [mobileMixin],
  props: {
    imgTitleData: {
      type: Object,
      required: true,
      default: {},
    },
    jumpToHtml: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      globals,
      i18n: viewSiteContent.imageTitle,
      backgroundImg: '',
    };
  },
  computed: {
    backgroundStyle() {
      return !this.backgroundImg
        ? {
          'background-color': this.imgTitleData.backgroundColor
            ? this.imgTitleData.backgroundColor
            : '',
        }
        : {
          'background-image': `url(${this.backgroundImg})`,
        };
    },

    imageTileWidth() {
      if (this.imgTitleData.noOfColumns) {
        return `width: ${100 / this.imgTitleData.noOfColumns}%`;
      }
      return 'width: 100%';
    },

    backgroundAlt() {
      return this.getResponsiveAlt(
        this.imgTitleData.backgroundImageAltTextD,
        this.imgTitleData.backgroundImageAltTextT,
        this.imgTitleData.backgroundImageAltTextM,
      );
    },
  },
  async mounted() {
    this.backgroundImg = this.getResponsiveImage(
      this.imgTitleData.backgroundImageD,
      this.imgTitleData.backgroundImageT,
      this.imgTitleData.backgroundImageM,
    );
  },
  methods: {
    /**
     * Emitting the event to open video player by sending video source url.
     * @param {String} videoSRC
     */
    openModal(videoSRC) {
      eventBus.$emit('open-player', videoSRC);
    },
    /**
     * Emitting the event to scroll the page to a particular position by giving the hash id.
     * @param {String} link
     */
    emitScrollSignal(link) {
      globalEventBus.$emit('scroll-to', link);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/view-site-content/vx-image-title/vx-image-title.js